module.exports = __webpack_public_path__ + "img/21.dc025271.jpg";